import { render, staticRenderFns } from "./bowelPreparation.vue?vue&type=template&id=45787d96&scoped=true"
import script from "./bowelPreparation.vue?vue&type=script&lang=js"
export * from "./bowelPreparation.vue?vue&type=script&lang=js"
import style0 from "./bowelPreparation.vue?vue&type=style&index=0&id=45787d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45787d96",
  null
  
)

export default component.exports